// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2h72I","col":"styles_col__3FZvl"};